import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { ActivatedRoute } from '@angular/router';

export interface instructor {
  nombre: string;
  email: string;
  resumen: string;
  empresaNombre: string;
  empresaId: string;
  foto: string;
  cantCursos: number;
  cantVentas: number;
  firma: string;
  id: string;
  descripcion: string;
  publicado: boolean;
  sitioWeb: string;
}

export interface curso {
  titulo: string;
  id: string;
  fechaCreacion: any;
  precioOriginal: string;
  porcentajeDescuento: string;
  precioFinal: string;
  cantVentas: number;
  publicado: boolean;
}

export interface pago {
  pagoId: string;
  pagoTotal: number;
  instructorFechaPago: any;
  instructorNombre: string;
  instructorId: string;
  instructorViaPago: string;
  instructorEstatusPago: string;
}

export interface venta {
  usuarioNombre: string;
  usuarioTipo: string;
  cursoTitulo: string;
  cursoPrecioOriginal: number;
  cursoPorcentajeDescuento: number;
  cursoPrecioFinal: number;
  transaccionMoneda: string;
  transaccionFecha: any;
  transaccionEstatusCobro: string;
  transaccionViaCobro: string;
  transaccionId: string;
  transaccionComentario: string;
  instructorPorcentaje: number;
  instructorId: string;
  instructorTotal: number;
  instructorEstatusPago: string;
  instructorFechaPago: any;
  instructorViaPago: string;
  pagoId: string;
}

@Component({
  selector: 'resumen-instructor',
  templateUrl: './resumen-instructor.component.html',
  styleUrls: ['./resumen-instructor.component.css']
})

export class ResumenInstructorComponent implements OnInit {

  // Default 
  loaded = 0;  //flag para mostrar spinner
  id = this.route.snapshot.paramMap.get('id'); //verifica si existe un id en la ruta activa
  userData: any;

  // Propias del componente
  instructor: instructor;
  cursos: curso[] = [];
  ventas: venta[] = []; // array de tipo venta
  pagos: pago[] = [];
  cantInscritos: number = 0;
  gananciaAcum: number = 0;
  porCobrar: number = 0;

  constructor(
    private afs: AngularFirestore,
    private afAuth: AngularFireAuth,
    private route: ActivatedRoute,
  ) { }

  usuario;
  token;

  ngOnInit(): void {
    this.usuario = JSON.parse(localStorage.getItem('user'));
    this.token = JSON.parse(localStorage.getItem('token'));
    if (this.token == "instructor") {
      this.cargarInstructor(this.usuario.instructorId);
    } else {
      this.cargarInstructor(this.id);
    }
  }

  cargarInstructor(id) {
    this.afs.collection("instructores").doc(id).ref.get().then((snap) => {
      const data = snap.data();
      this.instructor = {
        nombre: data["nombre"],
        email: data["email"],
        resumen: data["resumen"],
        empresaNombre: data["empresaNombre"],
        empresaId: data["empresaId"],
        foto: data["foto"],
        cantCursos: data["cantCursos"],
        cantVentas: data["cantVentas"],
        firma: data["firma"],
        id: data["id"],
        descripcion: data["descripcion"],
        publicado: data["publicado"],
        sitioWeb: data["sitioWeb"],
      }
      return this.getVentas(id);
    }).catch((error) => {
      return console.log(error);
    })
  }

  getVentas(id) {
    this.afs.doc("global/indiceVentas").get().subscribe(snap => {
      const ventas = snap.data();
      let arr = []
      Object.keys(ventas).map(function (key) {
        arr.push(ventas[key])
        return arr;
      });
      const length = arr.length
      let arreglo = []
      for (let index = 0; index < length; index++) {
        const ventas: venta = {
          usuarioNombre: arr[index].usuarioNombre,
          usuarioTipo: arr[index].usuarioTipo,
          cursoTitulo: arr[index].cursoTitulo,
          cursoPorcentajeDescuento: arr[index].cursoPorcentajeDescuento,
          cursoPrecioOriginal: arr[index].cursoPrecioOriginal,
          cursoPrecioFinal: arr[index].cursoPrecioFinal,
          transaccionMoneda: arr[index].transaccionMoneda,
          transaccionFecha: arr[index].transaccionFecha,
          transaccionEstatusCobro: arr[index].transaccionEstatusCobro,
          transaccionViaCobro: arr[index].transaccionViaCobro,
          transaccionId: arr[index].transaccionId,
          transaccionComentario: arr[index].transaccionComentario,
          instructorId: arr[index].instructorId,
          instructorPorcentaje: arr[index].instructorPorcentaje,
          instructorTotal: arr[index].instructorTotal,
          instructorEstatusPago: arr[index].instructorEstatusPago,
          instructorFechaPago: arr[index].instructorFechaPago,
          instructorViaPago: arr[index].instructorViaPago,
          pagoId: arr[index].pagoId,
        }
        arreglo.push(ventas)

        if (ventas.instructorId == this.id) {
          this.gananciaAcum = this.gananciaAcum + ventas.instructorTotal;
          this.cantInscritos = this.cantInscritos + 1;
          if (ventas.instructorEstatusPago == 'pendiente') {
            this.porCobrar = this.porCobrar + ventas.instructorTotal;
          }
        }
      }
      this.ventas = arreglo
      if (id) {
        this.ventas = this.ventas.filter(x => x.instructorId.includes(id))
        this.ventas.sort((a, b) => b.transaccionFecha - a.transaccionFecha)
      }

    })
    this.getCursosInstructor(id);
  }

  getCursosInstructor(id) {
    this.afs.doc("global/indiceCursos").get().subscribe(snap => {
      const cursos = snap.data();
      let arr = []
      Object.keys(cursos).map(function (key) {
        arr.push(cursos[key])
        return arr;
      });
      const length = arr.length
      let arreglo = []
      for (let index = 0; index < length; index++) {
        arreglo.push(arr[index])
      }
      this.cursos = arreglo.filter(t => t.instructorId == id);
      this.cargarPagosInstructor(id)
    })
  }

  cargarPagosInstructor(id) {
    this.afs.collection('instructoresPagos').ref.where('instructorId', "==", id).get().then(response => {
      response.docs.forEach(doc => {
        const data = doc.data();
        const pago: pago = {
          pagoId: doc.id,
          pagoTotal: data["pagoTotal"],
          instructorFechaPago: data["instructorFechaPago"],
          instructorNombre: data["instructorNombre"],
          instructorId: data["instructorId"],
          instructorViaPago: data["instructorViaPago"],
          instructorEstatusPago: data["instructorEstatusPago"],
        }
        this.pagos = this.pagos.concat(pago);
      })
      this.loaded = 1;
    })
  }

}
